import styled from 'styled-components'

export const TaskTitleUpdateActionLoadingWrapper = styled.div`
   margin: 42px 30px 16px 20px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   & > span {
      display: flex;
      flex-grow: 1;
   }
`

export const TaskIdAndActionsLoadingWrapper = styled.div`
   display: flex;
   align-items: center;
   padding-bottom: 16px;
   border-bottom: 1px solid rgb(228, 231, 235);
   margin-left: 20px;
   margin-right: 24px;
`
export const TaskDetailedViewWrapper = styled.div`
   display: flex;
   flex-direction: column;
   width: 100%;
`
export const HeaderLoadingWrapper = styled.div`
   display: flex;
   flex-direction: column;
   width: 100%;
`
export const TaskDescriptionContainer = styled.div`
   display: flex;
   & > span {
      display: flex;
      flex-grow: 1;
   }
`

export const TaskDescriptionLoadingWrapper = styled.div`
   margin-left: 20px;
   margin-right: 30px;
   margin-top: 24px;
`
export const TaskFieldsLoadingWrapper = styled.div`
   display: flex;
   flex-wrap: wrap;
   justify-content: space-between;
   margin-left: 20px;
   margin-top: 24px;
`
export const FieldLoadingWrapper = styled.div`
   display: flex;
   flex-direction: column;
   margin-bottom: 24px;
`
